// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// @ts-ignore
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueParticles from 'vue-particles'
// import global from './utils/global';

const echarts = require('echarts')
Vue.prototype.$echarts = echarts

// 全局菜单
Vue.prototype.$menu = JSON.parse(localStorage.getItem('menu')) || [];
Vue.use(ElementUI)
Vue.use(VueParticles)
Vue.config.productionTip = false
const loginUrl = process.env.LOGIN_URL
const apiBaseUrl = process.env.API_BASE_URL
const userinfo = JSON.parse(localStorage.getItem('userinfo') || (sessionStorage.getItem('userinfo'))) || {};
if (userinfo.api_token === '' || userinfo.api_token === null || userinfo.api_token === undefined) {
  window.location.href = loginUrl
}
Vue.prototype.$userinfo = userinfo

axios.defaults.headers.common['x-authorization-token'] = userinfo.api_token
axios.defaults.baseURL = apiBaseUrl

// 请求拦截
axios.interceptors.request.use(config => {
  return config // 放行
}, err => {
  Vue.prototype.$notify({
    title: 'ERROR',
    message: err.message
  })
})

// 响应拦截
axios.interceptors.response.use(response => {
  let code = response.data.code
  if (code === 200) {
    return response // 放行
  } else if (code === 401 || code === 402) {
    Vue.prototype.$notify({
      title: response.data.data,
      message: 'login in 2 secs',
      type: 'warning'
    })
    setTimeout(() => {
      sessionStorage.clear()
      localStorage.removeItem('userinfo')
      window.location.href = loginUrl
    }, 2000)
  } else {
    Vue.prototype.$notify.error({
      title: 'FAILED',
      message: response.data.data
    })
  }
}, err => {
  Vue.prototype.$notify({
    title: 'ERROR',
    message: err.message
  })
})
Vue.prototype.$axios = axios


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js